import * as classNames from "classnames";
import { AddCommentFormWrapper, AddCommentFormRenderProps } from "../addCommentFormWrapper";
import { ArticleCommentWrapper, ArticleCommentRender, ArticleCommentRenderProps } from "../articleCommentWrapper";
import { getTalkbackNumberView } from "../../articleSocialShare1280Component/articleSocialShareNew1280";
import { MutamArticleCommentsPopupRenderProps } from "../mutamArticleCommentsPropsWrapper";
import { getTranslation } from "../translations";
import { AddCommentFormUI2026 } from "./ynetAddCommentFormUI2026";
import { ArticleCommentUI2026 } from "./ynetArticleCommentUI2026";

const CLOSE_ANIMATION_MS = 280;

interface ArticleCommentsPopupProps {
    props: MutamArticleCommentsPopupRenderProps
}

interface MutamPopupState {
    isSortMenuVisible: boolean
    dragStartY: number | null
    dragOffsetY: number
    isClosing: boolean
}

export class MutamArticleCommentsPopupU2026 extends React.Component<ArticleCommentsPopupProps, MutamPopupState> {

    constructor(props: ArticleCommentsPopupProps) {
        super(props);
        this.state = {
            isSortMenuVisible: false,
            dragStartY: null,
            dragOffsetY: 0,
            isClosing: false,
        };
    }

    private commentsWrapperRef: HTMLElement | null = null;
    private lastScrollTop: number = 0;
    private closeTimer: ReturnType<typeof setTimeout> | null = null;

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('commentsPopupOpened'));

        }
    }

    componentDidUpdate(prevProps: ArticleCommentsPopupProps) {
        const wasVisible = prevProps.props.isAllCommentsPopupVisable;
        const isVisible = this.props.props.isAllCommentsPopupVisable;
        if (!wasVisible && isVisible) {
            this.setState({
                dragStartY: null,
                dragOffsetY: 0,
                isClosing: false,
            });
            setTimeout(() => {
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent('commentsPopupOpened'));
                }
            }, 50);
            const syntheticEvent = {
                target: { value: this.props.props.sortSelection }
            };
            this.props.props.handleSortSelection(syntheticEvent);
            this.attachScrollListener();
        }
        if (prevProps.props !== this.props.props) {
            this.setState({
                isSortMenuVisible: false
            });
        }
        else if (wasVisible && !isVisible) {
            this.removeScrollListener();
        }

    }

    componentWillUnmount() {
        this.removeScrollListener();
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    }

    private removeScrollListener = () => {
        if (this.commentsWrapperRef) {
            this.commentsWrapperRef.removeEventListener('scroll', this.handleScroll);
            this.commentsWrapperRef = null;
        }
    }

    private handleScroll = () => {
        const { isAddCommentFormVisible, handleCloseCommentForm } = this.props.props;

        if (this.commentsWrapperRef) {
            const currentScrollTop = this.commentsWrapperRef.scrollTop;

            // Only work on scroll down
            if (currentScrollTop > this.lastScrollTop) {
                // Close sort menu
                this.setState(() => ({
                    isSortMenuVisible: false
                }));

                // Close form if visible and not on screen
                if (isAddCommentFormVisible) {
                    const formElement = document.querySelector('#ArticleCommentsPopup .mainFormWrapper .AddCommentFormUI2026') as HTMLElement;

                    if (formElement) {
                        const formRect = formElement.getBoundingClientRect();
                        const wrapperRect = this.commentsWrapperRef.getBoundingClientRect();

                        // Check if form is out of view (scrolled past the top of the wrapper)
                        const isFormVisible = formRect.bottom > wrapperRect.top && formRect.top < wrapperRect.bottom;

                        if (!isFormVisible) {
                            handleCloseCommentForm();
                        }
                    }
                }
            }

            this.lastScrollTop = currentScrollTop;
        }
    }

    private attachScrollListener = () => {
        const commentsWrapper = document.querySelector('#ArticleCommentsPopup .commentsWrapper') as HTMLElement;
        if (commentsWrapper) {
            this.commentsWrapperRef = commentsWrapper;
            commentsWrapper.addEventListener('scroll', this.handleScroll);
        }
    }

    private requestClose = () => {
        if (this.state.isClosing) {
            return;
        }
        const offScreenY = typeof window !== "undefined" ? window.innerHeight : 1000;
        const fromY = Math.max(this.state.dragOffsetY, 0);
        // Hold at the current drag Y, then animate the rest of the way off-screen
        this.setState({
            isClosing: true,
            dragStartY: null,
            dragOffsetY: fromY,
        }, () => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.setState({ dragOffsetY: offScreenY });
                });
            });
        });
        this.closeTimer = setTimeout(() => {
            this.props.props.handleCommentsPopupClose();
            this.setState({ isClosing: false, dragOffsetY: 0 });
            this.closeTimer = null;
        }, CLOSE_ANIMATION_MS);
    }

    private onHandleTouchStart = (e: React.TouchEvent) => {
        if (this.state.isClosing) {
            return;
        }
        this.setState({ dragStartY: e.touches[0].clientY });
    }

    private onHandleTouchMove = (e: React.TouchEvent) => {
        const { dragStartY, isClosing } = this.state;
        if (dragStartY == null || isClosing) {
            return;
        }
        const delta = e.touches[0].clientY - dragStartY;
        if (delta > 0) {
            this.setState({ dragOffsetY: delta });
        }
    }

    private onHandleTouchEnd = () => {
        if (this.state.dragOffsetY > 80) {
            this.requestClose();
        } else {
            this.setState({ dragOffsetY: 0, dragStartY: null });
        }
        this.setState({ dragStartY: null });
    }

    private onBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            this.requestClose();
        }
    }

    private handleOnAddCommentBtnPress = (e) => {
        const { handleFormVisibility } = this.props.props
        handleFormVisibility();

        // Reset scroll position to top first
        if (this.commentsWrapperRef) {
            this.commentsWrapperRef.scrollTop = 0;
        }

        setTimeout(() => {
            const formElement = document.querySelectorAll('#ArticleCommentsPopup .mainFormWrapper .AddCommentFormUI2026')[0];
            if (formElement) {
                formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    }

    private toggleSortMenu = () => {
        this.setState((prevState) => ({
            isSortMenuVisible: !prevState.isSortMenuVisible
        }));
    }

    private handleSelectionSort = (e) => {
        const { handleSortSelection } = this.props.props
        const value = e.currentTarget.getAttribute('value');
        // Create a synthetic event object that matches what the parent expects
        const syntheticEvent = {
            target: { value: value }
        };
        handleSortSelection(syntheticEvent)
        this.setState({ isSortMenuVisible: false });
    }

    render() {
        const { lang, siteName,articleId, comments, IdOfLastTalkbackExpandedByUser, updateArticleCommentsStorageState, areAllCommentsExpanded, numOfComments, showFormWhenEmpty,
            isAddCommentFormVisible, handleCloseCommentForm, isAllCommentsPopupVisable, handleCommentsPopupClose, isFirmaMobileWeb, sortSelection,
            loadMoreComments, hasMore, postId, domain } = this.props.props
        const { dragOffsetY, isClosing, dragStartY } = this.state;

        const isOverlayVisible = isAllCommentsPopupVisable || isClosing;

        const overlayClasses = classNames({
            "ArticleCommentsPopupOverlay": true,
            "hide": !isOverlayVisible,
            "is-closing": isClosing,
            "fadeIn": isAllCommentsPopupVisable && !isClosing,
        })

        const commentsPopupClasses = classNames({
            "ArticleCommentsPopup type2026": true,
        })

        const addCommentBtnClasses = classNames({
            "addCommentBtn": true,
            "fadeIn": !isAddCommentFormVisible,
            "hide": isAddCommentFormVisible,
        })

        let ArticleCommentRender: ArticleCommentRender;
        ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentUI2026 props={{ ...props, notPopupMode: false }} />;
        let sortSelectionLabel = "";

        if (sortSelection == "end_to_start") {
            sortSelectionLabel = getTranslation(lang, "End To Start");
        } else if (sortSelection == "start_to_end") {
            sortSelectionLabel = getTranslation(lang, "Start To End");
        } else if (sortSelection == "recommended") {
            sortSelectionLabel = getTranslation(lang, "Recommended");
        }

        const isDragging = dragStartY != null;
        const sheetStyle = (dragOffsetY > 0 || isClosing)
            ? {
                transform: `translateY(${dragOffsetY}px)`,
                transition: isDragging ? "none" : `transform ${CLOSE_ANIMATION_MS}ms cubic-bezier(0.32, 0.72, 0, 1)`,
            } as React.CSSProperties
            : {
                transition: `transform ${CLOSE_ANIMATION_MS}ms cubic-bezier(0.32, 0.72, 0, 1)`,
            } as React.CSSProperties;

        return (
            <div className={overlayClasses} onClick={this.onBackdropClick}>
                <section className={commentsPopupClasses} id="ArticleCommentsPopup" role="dialog" aria-modal="true" aria-label={getTranslation(lang, "Comments")} onClick={e => e.stopPropagation()} style={sheetStyle}>
                    <div className="popupHandleArea" onTouchStart={this.onHandleTouchStart} onTouchMove={this.onHandleTouchMove} onTouchEnd={this.onHandleTouchEnd}>
                        <div className="popupHandle" />
                    </div>

                    <div className="commentsTopBar">
                        <div className="titlesContainer">
                            <div className="headlineTitle">{getTranslation(lang, "Comments")}</div>

                            <div className="commentsCountContainer">
                                {`${getTalkbackNumberView(numOfComments.toString())} ${getTranslation(lang, "Comments")}`}
                            </div>
                        </div>

                        <div role="button" className={addCommentBtnClasses} aria-label={getTranslation(lang, "New Comment(premium)")} onClick={this.handleOnAddCommentBtnPress}>{getTranslation(lang, "New Comment(premium)")}</div>
                    </div>

                    <div className="commentsWrapper">
                        <AddCommentFormWrapper
                            lang={lang}
                            siteName={siteName}
                            postId={postId}
                            formType={"NEW"}
                            articleId={articleId}
                            shouldTitleBeHidden={true}
                            handleCloseCommentForm={handleCloseCommentForm}
                            isAddCommentFormVisible={isAddCommentFormVisible}
                            isFirstComment={showFormWhenEmpty && numOfComments === 0}
                            render={(props: AddCommentFormRenderProps) => <AddCommentFormUI2026 props={{ ...props, shouldTitleBeHidden: true, siteName: siteName }} />}
                        />

                        <div className="sortSelectWrapper">
                            <div className="sortSelect" role="button" tabIndex={0} aria-label={getTranslation(lang, "Sort By")} onClick={this.toggleSortMenu}>   {getTranslation(lang, "Sort By")} {sortSelectionLabel}   <div className={this.state.isSortMenuVisible ? "menuToggler toClose" : "menuToggler toOpen"} /></div>

                            <div className={classNames("optionsMenu", { "isVisible": this.state.isSortMenuVisible })}>
                                <div className="sortOption" onClick={this.handleSelectionSort} id="logoutDesktopYnet" value="end_to_start">{getTranslation(lang, "End To Start")}</div>
                                <div className="sortOption" onClick={this.handleSelectionSort} id="logoutDesktopYnet" value="start_to_end">{getTranslation(lang, "Start To End")}</div>
                                <div className="sortOption" onClick={this.handleSelectionSort} id="logoutDesktopYnet" value="recommended">{getTranslation(lang, "Recommended")}</div>
                            </div>
                        </div>

                        <ol className="commentsContainer">
                            {comments.map((comment, i) =>
                                <li key={`comment_${comment.id}`}>
                                    <ArticleCommentWrapper
                                        lang={lang}
                                        siteName={siteName}
                                        isFirma={null}
                                        domain={domain}
                                        comment={comment}
                                        articleId={articleId}
                                        isNewTemplate2026={true}
                                        render={ArticleCommentRender}
                                        isFirmaMobileWeb={isFirmaMobileWeb}
                                        isAutoExpanded={areAllCommentsExpanded}
                                        handleCommentsPopupClose={handleCommentsPopupClose}
                                        isAllCommentsPopupVisable={isAllCommentsPopupVisable}
                                        IdOfLastTalkbackExpandedByUser={IdOfLastTalkbackExpandedByUser}
                                        handleUpdateArticleCommentsStorageState={updateArticleCommentsStorageState}
                                    />
                                </li>
                            )}
                        </ol>

                        {hasMore &&
                            <div className="showMoreCommentsButton" onClick={e => loadMoreComments()}>
                                {getTranslation(lang, "Show more")}
                            </div>}
                    </div>
                </section>
            </div>
        )
    }
}
